// extracted by mini-css-extract-plugin
export default {"AdSection":"AdSection_AdSection__uU3ZW","content":"AdSection_content__5DVcZ","title":"AdSection_title__O15Sa"};